import { Emitter } from "mitt";
import { createContext, useContext } from "react";

import { GlobalAppEvents } from "@ryde/shared";

// Deep import, not the `../hooks` barrel: hooks reach this context through `../contexts`, so the barrel
// would close a cycle.
import {
  initialUseAuthModel,
  UseAuthModel,
} from "../hooks/auth-profile/use-auth";

export interface ICompanyScopeContext {
  auth: UseAuthModel;
  isHybridWidgetMode?: boolean;
  eventEmitter?: Emitter<GlobalAppEvents>;
}

const initialContext: ICompanyScopeContext = {
  auth: initialUseAuthModel,
  isHybridWidgetMode: false,
};

const CompanyScopeContext = createContext<ICompanyScopeContext>(initialContext);

CompanyScopeContext.displayName = "Company Scope";

export const useCompanyScopeContext = (): ICompanyScopeContext =>
  useContext(CompanyScopeContext);

export { CompanyScopeContext };
